import { TradeStatus, activeTradeStatuses, statusColorMap } from './constants';
import StatusIndicator from '../StatusIndicator';

type OwnProps = {
  tradeStatus: TradeStatus;
};

export default function Status({ tradeStatus }: OwnProps) {
  const daysToExpired = 7; // TODO REO-2947 update this once we have have daysToExpired or similar from STC

  const statusText = activeTradeStatuses[tradeStatus]
    ? `Expires ${daysToExpired} days`
    : `Offer ${tradeStatus}`;

  return (
    <StatusIndicator
      statusColor={statusColorMap[tradeStatus]}
      text={statusText}
    />
  );
}
